import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import CreatorInfo from "../creatorInfo/CreatorInfo";
import RaikoImageCropper from "../raikoImageCropper/RaikoImageCropper";
import {useParams} from "react-router-dom";
import {MagazineWriterService} from "../../serverService/magazineService/MagazineWriterService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoDivider
} from "@moeindal/base-raiko-panel-components";

export default function WriterPersonInfo() {

    const {id: writerId} = useParams()

    const service = new MagazineWriterService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    function getWriterInfo() {
        loading.show()
        service.getWriterInformation(writerId)
            .then(response => {
                setFirstName(response.firstName)
                setLastName(response.lastName)
                setNationalCode(response.nationalCode)
                setPhoneNumber(response.phoneNumber)

                setCreateBy(response.createdBy)
                setCreateAt(response.createdAt)

            }).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    useEffect(() => {
        if (typeof writerId !== 'undefined' && writerId > 0) {
            getWriterInfo();
        }
    }, [writerId]);

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const [createBy, setCreateBy] = useState("");
    const [createAt, setCreateAt] = useState("");

    function checkFields() {
        let message = ""
        let state = false

        if (firstName.trim().length === 0)
            message = "لطفا نام نویسنده را به درستی وارد نمایید."
        else if (lastName.trim().length === 0)
            message = "لطفا نام خانوادگی نویسنده را به درستی وارد نمایید."
        else if (nationalCode.length < 7 || nationalCode.length > 11)
            message = "لطفا کد ملی نویسنده را به درستی وارد نمایید."
        else if (phoneNumber.length !== 11)
            message = "لطفا شماره همراه نویسنده را به درستی وارد نمایید."
        else
            state = true

        if (message.length > 0)
            snackbar.showWarningMessage(message)
        return state
    }

    function handleUpdateInfo() {
        if (checkFields()) {
            loading.show()
            service.updateWriterInformation(
                writerId,
                firstName,
                lastName,
                nationalCode,
                phoneNumber
            ).then(response => {
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                snackbar.showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem`}>

            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                        hasActionButton
                        actionButtonOnclick={handleUpdateInfo}
                    >
                        <RaikoImageCropper/>
                        <RaikoDivider/>
                        <RaikoGridTwoColumn className={css`margin-top: .5rem`}>
                            <RaikoSimpleInputOutlined
                                labelText={"نام"}
                                setValue={setFirstName}
                                value={firstName}
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"نام خانوادگی"}
                                setValue={setLastName}
                                value={lastName}
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"کد ملی"}
                                setValue={setNationalCode}
                                value={nationalCode}
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"شماره همراه"}
                                setValue={setPhoneNumber}
                                value={phoneNumber}
                            />
                        </RaikoGridTwoColumn>
                    </RaikoSectionContainer>
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>

            <CreatorInfo createdAt={createAt} createdBy={createBy}/>

        </RaikoGridOneColumn>
    )
}
